import { css } from '@emotion/react';
import { Box } from '@spark-web/box';
import { Divider } from '@spark-web/divider';
import { Text } from '@spark-web/text';

import { CHANNEL_REQUIREMENTS } from '~/constants';
import { MarketplaceChannel, MarketplacePartner } from '~/types/marketplace';
import { getBrighteSitePartnerUrl } from '~/utils/formatter';

import { BrighteLogo } from './common/brighte-logo';
import { Logo } from './logo';

export const BRIGHTE_LOGO_HEIGHT = 30;

type HeaderLogosProps = {
  channel: MarketplaceChannel | null;
  partner?: MarketplacePartner;
};

export const HeaderLogos = ({ channel, partner }: HeaderLogosProps) => {
  const channelConfig = channel ? CHANNEL_REQUIREMENTS[channel] : null;
  const channelLogo = channelConfig?.logo;

  return (
    <Box display="flex" flexDirection="row" gap="xsmall" alignItems="center">
      <Box>
        <a target="_blank" rel="noreferrer" href={getBrighteSitePartnerUrl(partner)} style={{ textDecoration: 'none' }}>
          {channelLogo ? (
            <Box display="flex" flexDirection="column" alignItems="center">
              {channelConfig.showProvidedBy ? (
                <Text size="xsmall" css={css({ paddingBottom: 5 })}>
                  Provided by
                </Text>
              ) : null}
              <BrighteLogo height={BRIGHTE_LOGO_HEIGHT} />
            </Box>
          ) : (
            <BrighteLogo height={BRIGHTE_LOGO_HEIGHT} />
          )}
        </a>
      </Box>
      {channelLogo ? (
        <Box display="flex" flexDirection="row" gap="medium" cursor="pointer">
          <Divider vertical />
          <Logo partner={partner} channel={channel} />
        </Box>
      ) : null}
    </Box>
  );
};
